import { useEffect, useState } from "react";
import { syncScheduler, type SyncStatus as Status } from "../../data/sync/scheduler";

/**
 * Connection and pending-upload indicator (FR-047).
 *
 * Staff need to know, without asking, whether the day's takings have reached
 * the server. It is deliberately unobtrusive when everything is fine and
 * unmissable when records are waiting — an indicator nobody notices during an
 * outage is worse than none, because it implies all is well.
 */

export function SyncStatusIndicator() {
  const [status, setStatus] = useState<Status>(syncScheduler.status);

  useEffect(() => syncScheduler.subscribe(setStatus), []);

  const offline = !status.online;
  const waiting = status.pending > 0;

  const tone = offline ? "is-offline" : waiting ? "is-waiting" : "is-synced";
  const label = offline
    ? status.pending > 0
      ? `Offline · ${status.pending} to upload`
      : "Offline"
    : status.syncing
      ? "Syncing…"
      : waiting
        ? `${status.pending} to upload`
        : "Synced";

  return (
    <button
      type="button"
      className={`syncstatus ${tone}`}
      onClick={() => void syncScheduler.syncNow(true)}
      title={
        offline
          ? "Sales are recorded on this device and will upload when the connection returns."
          : status.lastSyncAt
            ? `Last synced ${new Date(status.lastSyncAt).toLocaleTimeString()}`
            : "Not yet synced"
      }
    >
      <span className="syncstatus__dot" aria-hidden="true" />
      <span className="syncstatus__label">{label}</span>
    </button>
  );
}

export default SyncStatusIndicator;
